module.exports = __webpack_public_path__ + "static/img/pro_display_3.4376a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_3.jpg
// module id = 2eOY
// module chunks = 1